import "angular-i18n/angular-locale_en-us";
// eslint-disable-next-line no-restricted-imports
import dayjs from "dayjs";
import "dayjs/locale/en";
import lang from "../../../../../localization/lang_en.json";
import { currentTexts } from "../localize";

currentTexts.map = lang.l;

dayjs.locale("en-us");

export * from "@webapp/localization/locale/en-us";
